module.exports = __webpack_public_path__ + "img/grillentanz.378f149b.jpg";